import { themeObject } from 'lib';

export interface ConfirmationModalProps {
    confirmationKey?: string;
    confirmationModal: boolean;
    hasConfirmationTextField?: boolean;
    handleConfirmationModal: () => void;
    confirmationButtonText: string;
    confirmationCancelButtonText?: string;
    confirmationCancelButtonArrowIcon?: boolean;
    confirmationHeadingText: string;
    confirmationInputLabelText?: string | React.JSX.Element;
    confirmationSubHeadingText: React.JSX.Element;
    handleConfirmation: () => void;
    isRequiredIconVisible?: boolean;
    children?: React.ReactNode;
}

export const styles = {
    dialogStyles: {
        '& .MuiPaper-root': {
            maxWidth: '462px',
            height: 'auto',
            '& .MuiDialogContent-root': {
                p: '0px 35px 35px 35px',
                overflow: 'auto',
            },
        },
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        mt: 2.5,
    },
    textBoldStyles: {
        fontWeight: 600,
    },
    textFieldContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 2.5,
        '& .MuiFormControl-root': {
            width: '290px',
        },
    },
    textFieldLabelStyles: {
        ...themeObject.typography.Components.inputLabel,
        color: themeObject.palette.grayScale[800],
        mb: '4px',
        width: '74%',
        display: 'flex',
    },
    textFieldRequiredStyles: {
        color: themeObject.palette.tertiary.red[300],
    },
    maxWidthStyles: {
        maxWidth: '100%',
    },
    wordBreakStyles: {
        wordBreak: 'break-all',
    },
};
